import { IShortCodeLink } from './short-code-link';

export interface ISaveShortCodeLinkResponse {
    data: {
        success: boolean;
        results: IShortCodeLink;
        message: string;
    }
}
